import { render, staticRenderFns } from "./NavigationLinkByColor.vue?vue&type=template&id=08cad638"
import script from "./NavigationLinkByColor.vue?vue&type=script&lang=ts"
export * from "./NavigationLinkByColor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports